/* eslint-disable prefer-promise-reject-errors */

// TODO: reuse types from constants/contentModules after resolving circular dependancy error
export const TYPE = {
  TOP_RANKINGS: {
    value: 'topRankings',
    label: 'Top Rankings',
  },
  WORLD_RECORDS: {
    value: 'worldRecords',
    label: 'World Records',
  },
  WORLD_LEADING_ATHLETES: {
    value: 'worldLeadingAthletes',
    label: 'World Leading Athletes',
  },
};
export const TYPES = Object.values(TYPE);

export const INITIAL_VALUES = {
  type: TYPE.TOP_RANKINGS.value,
};
